import BEER_BUTTON_IMAGE_URL from '../assets/bombButtons/beer-button.png';
import BOMB_BUTTON_IMAGE_URL from '../assets/bombButtons/bomb-button.png';
import HEART_BUTTON_IMAGE_URL from '../assets/bombButtons/heart-button.png';
import PIE_BUTTON_IMAGE_URL from '../assets/bombButtons/pie-button.png';
import SHEEP_BUTTON_IMAGE_URL from '../assets/bombButtons/sheep-button.png';
import TRASH_BUTTON_IMAGE_URL from '../assets/bombButtons/trash-button.png';
import { BEER_BOMB_SPLAT_IMAGE_URL, BEER_BOMB_SPLAT_SPRITESHEET_DATA } from '../assets/bombs/beer/beerBombSplatSpritesheetData';
import { BEER_BOMB_IMAGE_URL, BEER_BOMB_SPRITESHEET_DATA } from '../assets/bombs/beer/beerBombSpritesheetData';
import { BOMB_BOMB_SPLAT_IMAGE_URL, BOMB_BOMB_SPLAT_SPRITESHEET_DATA } from '../assets/bombs/bomb/bombBombSplatSpritesheetData';
import { BOMB_BOMB_IMAGE_URL, BOMB_BOMB_SPRITESHEET_DATA } from '../assets/bombs/bomb/bombBombSpritesheetData';
import { HEART_BOMB_SPLAT_IMAGE_URL, HEART_BOMB_SPLAT_SPRITESHEET_DATA } from '../assets/bombs/heart/heartBombSplatSpritesheetData';
import { HEART_BOMB_IMAGE_URL, HEART_BOMB_SPRITESHEET_DATA } from '../assets/bombs/heart/heartBombSpritesheetData';
import { PIE_BOMB_SPLAT_IMAGE_URL, PIE_BOMB_SPLAT_SPRITESHEET_DATA } from '../assets/bombs/pie/pieBombSplatSpritesheetData';
import { PIE_BOMB_IMAGE_URL, PIE_BOMB_SPRITESHEET_DATA } from '../assets/bombs/pie/pieBombSpritesheetData';
import { SHEEP_BOMB_SPLAT_IMAGE_URL, SHEEP_BOMB_SPLAT_SPRITESHEET_DATA } from '../assets/bombs/sheep/sheepBombSplatSpritesheetData';
import { SHEEP_BOMB_IMAGE_URL, SHEEP_BOMB_SPRITESHEET_DATA } from '../assets/bombs/sheep/sheepBombSpritesheetData';
import { TRASH_BOMB_SPLAT_IMAGE_URL, TRASH_BOMB_SPLAT_SPRITESHEET_DATA } from '../assets/bombs/trash/trashBombSplatSpritesheetData';
import { TRASH_BOMB_IMAGE_URL, TRASH_BOMB_SPRITESHEET_DATA } from '../assets/bombs/trash/trashBombSpritesheetData';
export const ALL_BOMB_TYPES = ['pie', 'bomb', 'beer', 'heart', 'sheep', 'trash']; // TODO: add more!
export const ALL_BOMB_PROPERTIES = {
    pie: {
        bombType: 'pie',
        label: 'Pie',
        buttonImageUrl: PIE_BUTTON_IMAGE_URL,
        bombCost: 2,
        orientationType: 'path',
        strength: 0.5,
        bombSplatProperties: {
            scaleFactor: 1
        },
        spritesheetProperties: {
            bomb: {
                data: PIE_BOMB_SPRITESHEET_DATA,
                imageUrl: PIE_BOMB_IMAGE_URL
            },
            bombSplat: {
                data: PIE_BOMB_SPLAT_SPRITESHEET_DATA,
                imageUrl: PIE_BOMB_SPLAT_IMAGE_URL
            }
        }
    },
    bomb: {
        bombType: 'bomb',
        label: 'Bomb',
        buttonImageUrl: BOMB_BUTTON_IMAGE_URL,
        bombCost: 15,
        orientationType: 'spinning',
        strength: 3,
        tableShakeProperties: {
            type: 'vibrate',
            durationMs: 1000,
            maxVibratePx: 20,
            isIncreasingStrength: false
        },
        bombSplatProperties: {
            scaleFactor: 1
        },
        spritesheetProperties: {
            bomb: {
                data: BOMB_BOMB_SPRITESHEET_DATA,
                imageUrl: BOMB_BOMB_IMAGE_URL
            },
            bombSplat: {
                data: BOMB_BOMB_SPLAT_SPRITESHEET_DATA,
                imageUrl: BOMB_BOMB_SPLAT_IMAGE_URL
            }
        }
    },
    beer: {
        bombType: 'beer',
        label: 'Beer',
        buttonImageUrl: BEER_BUTTON_IMAGE_URL,
        bombCost: 16,
        orientationType: 'path',
        strength: 1,
        bombSplatProperties: {
            scaleFactor: 1
        },
        spritesheetProperties: {
            bomb: {
                data: BEER_BOMB_SPRITESHEET_DATA,
                imageUrl: BEER_BOMB_IMAGE_URL
            },
            bombSplat: {
                data: BEER_BOMB_SPLAT_SPRITESHEET_DATA,
                imageUrl: BEER_BOMB_SPLAT_IMAGE_URL
            }
        }
    },
    heart: {
        bombType: 'heart',
        label: 'Heart',
        buttonImageUrl: HEART_BUTTON_IMAGE_URL,
        bombCost: 15,
        orientationType: 'none',
        strength: 0.5,
        bombSplatProperties: {
            scaleFactor: 4,
            radiansRange: 0.2
        },
        spritesheetProperties: {
            bomb: {
                data: HEART_BOMB_SPRITESHEET_DATA,
                imageUrl: HEART_BOMB_IMAGE_URL
            },
            bombSplat: {
                data: HEART_BOMB_SPLAT_SPRITESHEET_DATA,
                imageUrl: HEART_BOMB_SPLAT_IMAGE_URL
            }
        }
    },
    sheep: {
        bombType: 'sheep',
        label: 'Sheep',
        buttonImageUrl: SHEEP_BUTTON_IMAGE_URL,
        bombCost: 20,
        orientationType: 'path',
        strength: 0.5,
        bombSplatProperties: {
            scaleFactor: 1
        },
        spritesheetProperties: {
            bomb: {
                data: SHEEP_BOMB_SPRITESHEET_DATA,
                imageUrl: SHEEP_BOMB_IMAGE_URL
            },
            bombSplat: {
                data: SHEEP_BOMB_SPLAT_SPRITESHEET_DATA,
                imageUrl: SHEEP_BOMB_SPLAT_IMAGE_URL
            }
        }
    },
    trash: {
        bombType: 'trash',
        label: 'Trash',
        buttonImageUrl: TRASH_BUTTON_IMAGE_URL,
        bombCost: 15,
        orientationType: 'path',
        strength: 0.5,
        bombSplatProperties: {
            scaleFactor: 1
        },
        spritesheetProperties: {
            bomb: {
                data: TRASH_BOMB_SPRITESHEET_DATA,
                imageUrl: TRASH_BOMB_IMAGE_URL
            },
            bombSplat: {
                data: TRASH_BOMB_SPLAT_SPRITESHEET_DATA,
                imageUrl: TRASH_BOMB_SPLAT_IMAGE_URL
            }
        }
    }
};
export function isBombType(str) {
    return str !== undefined && ALL_BOMB_TYPES.includes(str);
}
